import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AuthConfig, NullValidationHandler, OAuthModule, OAuthStorage, ValidationHandler } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

import { HttpErrorInterceptor, TRACKREQ_ENABLED } from './core/interceptors/http-error.interceptor';
import { LoaderInterceptor } from './core/interceptors/loading.interceptor';
import { RoleInterceptor } from './core/interceptors/role.interceptor';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from './core/interceptors/timeout.interceptor';
import { AUTO_LOGOUT } from './core/services/auto-logout.service';
import { ApiloaderService } from './shared/loaders/apiloader/apiloader.service';

export const authConfig: AuthConfig = {
  //useSilentRefresh: true,
  //silentRefreshRedirectUri: window.location.origin + '/silent-check-sso.html',
  timeoutFactor: 0.75,

  // Url of the Identity Provider
  issuer: environment.keycloak.issuer,

  // URL of the SPA to redirect the user to after login
  redirectUri: environment.keycloak.redirectUri,

  // The SPA's id.
  // The SPA is registerd with this id at the auth-serverß
  clientId: environment.keycloak.clientId,

  responseType: environment.keycloak.responseType,
  // set the scope for the permissions the client should request
  // The first three are defined by OIDC.
  scope: environment.keycloak.scope,
  // Remove the requirement of using Https to simplify the demo
  // THIS SHOULD NOT BE USED IN PRODUCTION
  // USE A CERTIFICATE FOR YOUR IDP
  // IN PRODUCTION
  requireHttps: environment.keycloak.requireHttps,
  strictDiscoveryDocumentValidation: false,
  skipIssuerCheck: environment.keycloak.skipIssuerCheck,
  disablePKCE: false,
  oidc: true,
  clockSkewInSec: 300, // Increase to 5 minutes to handle server/client drift
  checkOrigin: false,

  // at_hash is not present in JWT token
  showDebugInformation: environment.keycloak.showDebugInformation,
  disableAtHashCheck: environment.keycloak.disableAtHashCheck
};

export class OAuthModuleConfig {
  resourceServer: OAuthResourceServerConfig = { sendAccessToken: true };
}

export class OAuthResourceServerConfig {
  /**
   * Urls for which calls should be intercepted.
   * If there is an ResourceServerErrorHandler registered, it is used for them.
   * If sendAccessToken is set to true, the access_token is send to them too.
   */

  allowedUrls?: string[];
  sendAccessToken = true;
  customUrlValidation?: (url: string) => boolean;
}


@NgModule({
  imports: [
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [
          environment.apiUrl,
          environment.apiDocUrl,
          environment.apiBioUrl,
          environment.mcpApiUrl,
          environment.keycloakHost,
          '/uuid',
          '/getUserMenus',
        ],
        sendAccessToken: true,
      },
    }),
    // AuthModule.forRoot({
    //   config: {
    //     authority: 'https://dev-damienbod.eu.auth0.com',
    //     redirectUrl: window.location.origin,
    //     postLogoutRedirectUri: window.location.origin,
    //     clientId: 'Ujh5oSBAFr1BuilgkZPcMWEgnuREgrwU',
    //     scope: 'openid profile offline_access auth0-user-api-spa',
    //     responseType: 'code',
    //     silentRenew: true,
    //     useRefreshToken: true,
    //     logLevel: LogLevel.Debug,
    //     customParamsAuthRequest: {
    //       audience: 'https://auth0-api-spa',
    //     },
    //     customParamsRefreshTokenRequest: {
    //       scope: 'openid profile offline_access auth0-user-api-spa',
    //     },
    //   },
    // }),
  ],
  providers: [
    { provide: ApiloaderService, useClass: ApiloaderService },
    { provide: DEFAULT_TIMEOUT, useValue: 120000 },
    { provide: TRACKREQ_ENABLED, useValue: true },
    { provide: AUTO_LOGOUT, useValue: 420000 }, // 60000 * 7 = 7 minutes
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeAuth,
    //   deps: [OAuthService, UserService, TokenService],
    //   multi: true,
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      deps: [ApiloaderService],
      multi: true, // Allows multiple interceptors
    },
    { provide: ValidationHandler, useClass: NullValidationHandler,multi: true },
    { provide: AuthConfig, useValue: authConfig },
    { provide: OAuthStorage, useValue: localStorage },
    { provide: HTTP_INTERCEPTORS, useClass: RoleInterceptor },
    //{ provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor },
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor },
    // { provide: AbstractSecurityStorage, useClass: MyStorageService },
    // { provide: AbstractLoggerService, useClass: MyLoggerService },
  ],
  exports: [OAuthModule],
})
export class AuthConfigModule {}
